import React, { Component } from 'react';
import './spinner.css';

class Spinner extends Component {
  render() {
    return (
      <div className='spinner'>
        <div className='lds-ellipsis'>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}

export default Spinner;
